import { ERoleAccess } from "@/frontend/app/providers/router/config/routeConfig";
import { getStagesNameData } from "@/frontend/pages/DashboardPage/model/services/getStagesNameData";
import $api from "@/frontend/shared/api/axios";
import { useMe } from "@/frontend/shared/lib/hooks/useMe";
import { useQuery } from "@tanstack/react-query";

export function getStageNames() {
  return $api.get("/stages/names");
}

export function useStageNames(pipelineId?: number) {
  const { data: me } = useMe();

  const query = useQuery({
    queryKey: ["stages/names", pipelineId],
    queryFn: async () => {
      if (!pipelineId) return [];
      const response = await getStagesNameData({ pipelineId, trueColumnFilters: {} });
      return response.stages;
    },
    enabled: me?.entity === ERoleAccess.INVESTOR && !!pipelineId
  });

  return { ...query };
}
